import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SharingService {

  constructor() { }

  private approvalStageMessage = new BehaviorSubject<any>("mess");
  currentApprovalStageMessage = this.approvalStageMessage.asObservable();

  updateApprovalMessage(response: object) {
    if (JSON.stringify(this.approvalStageMessage.getValue()) !== JSON.stringify(response)) {
      this.approvalStageMessage.next(response);
    }
  }
}
